module.exports = __webpack_public_path__ + "img/flandre scarlet_lw.daaf3c82.png";